import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'gpArrayNumber'
})
export class CalendarArrayNumberPipe implements PipeTransform {

  public transform(value: number): number[] {
    return Array(value).fill(0).map((v, i) => i + 1);
  }
}
